import { z } from 'zod';
import { PortalsServiceEventBaseSchema, portalsServiceEventType } from './service.js';
const portalDatabaseEventType = (eventName) => portalsServiceEventType('database', eventName);
export const PortalDatabaseEventSchema = PortalsServiceEventBaseSchema.merge(z.object({
    type: portalDatabaseEventType(),
}));
export const PortalDatabaseWipedEventSchema = PortalDatabaseEventSchema.merge(z.object({
    type: portalDatabaseEventType('wiped'),
    table: z.string(),
    recordCount: z.number(),
    success: z.boolean(),
}));
